
const currentPath = window.location.pathname;
const pageId = getPageIdFromUrl(currentPath);
const isFirstPage = /^\/(guide|guide-preview)(\/|\/index\.html)?$/.test(currentPath);
const isGuidePreview = currentPath.startsWith("/guide-preview/");
let isOutlineFullyUnfolded = false;

if (isFirstPage) {
    const cover = document.getElementById("cover");
    cover?.classList.remove("hidden");
}

const logo = document.querySelector("#nav-title .logo") as HTMLImageElement;
if (logo) {
    logo.addEventListener("click", () => {
        window.location.href = isGuidePreview ? "/guide-preview/" : "/guide/";
    });
}

const navOutlineItems = document.querySelectorAll("#pages-outline .toc-level");
navOutlineItems.forEach(tocLevel => {
    const link = tocLevel.querySelector("a")!;
    const hasChildren = tocLevel.querySelector(".toc-level") !== null;
    if (hasChildren) {
        tocLevel.classList.add("has-children");
        const icon = link.querySelector(".icon")!;
        const chevron = document.createElement("span");
        chevron.className = "chevron";
        icon.appendChild(chevron);
        chevron.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            tocLevel.classList.toggle("expanded");
            if(!tocLevel.classList.contains("expanded")) {
                isOutlineFullyUnfolded = false;
                refreshOutlineUnfoldButton();
            }
        });
    }

    const linkHref = link.getAttribute("href")!;
    const linkPageId = getPageIdFromUrl(linkHref);
    let isExpanded = false;
    if (isGuidePreview && linkPageId == "" && linkHref != "index.html" && !linkHref.match(/^http(s)?:\/\//)) {
        link.classList.add("error");
        isExpanded = true;
    }
    if (linkHref === "index.html" && isFirstPage) {
        link.classList.add("active");
        isExpanded = true;
    }
    if (linkPageId === pageId && pageId !== "") {
        link.classList.add("active");
        isExpanded = true;
    }
    if (isExpanded) {
        let parent = link.parentElement;
        while (parent && parent.id !== "pages-outline") {
            if (parent.classList.contains("toc-level")) {
                parent.classList.add("expanded");
            }
            parent = parent.parentElement;
        }
    }
});

const authButtons = document.getElementById('auth-buttons');
const nameTag = document.querySelector('#profile-box .display-name') as HTMLSpanElement;
const profileBox = document.getElementById('profile-box');
if (profileBox) {
    profileBox.addEventListener('click', function(e) {
        e.stopPropagation();
        profileBox.classList.toggle('active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function() {
        profileBox.classList.remove('active');
    });
}

async function applyGuideOptions() {
    const guideOptionsRequest = fetch('/api/guide-options', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const userInfoRequest = fetch('/api/current-user-info', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    const [guideOptionsResponse, userInfoResponse] = await Promise.all([guideOptionsRequest, userInfoRequest]);
    let isPaidUser = false;

    if (!userInfoResponse.ok) {
        console.error("Failed to fetch user info:", userInfoResponse.statusText);
        return;
    }
    if (!guideOptionsResponse.ok) {
        console.error("Failed to fetch guide options:", guideOptionsResponse.statusText);
        return;
    }
    
    // We check user on the client only to adjust the display, real access control to the pages is done on the server
    const userInfo: any = await userInfoResponse.json();
    isPaidUser = userInfo && userInfo.isAuthenticated && userInfo.user && userInfo.user.paidTier > 0;

    // Update profile box
    if (profileBox && authButtons) {
        if (userInfo && userInfo.isAuthenticated && userInfo.user) {
            // User is connected - show profile box
            profileBox.classList.remove('hidden');
            authButtons.classList.add('hidden');
            if (nameTag) {
                nameTag.textContent = userInfo.user.name || 'Utilisateur';
            }
            if (userInfo.user.isAdmin) {
                const adminLink = profileBox.querySelector('.admin-link') as HTMLElement;
                if (adminLink) adminLink.style.display = 'block';
            }
        } else {
            // User is not connected - show auth buttons
            profileBox.classList.add('hidden');
            authButtons.classList.remove('hidden');
        }
    }

    // If we're on a preview guide, we can fake the paid/free status with a query param
    if (isGuidePreview) {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has("tier")) {
            const fakeTier = parseInt(currentUrl.searchParams.get("tier")!);
            isPaidUser = fakeTier > 0;
        }
    }
    
    const responseData = await guideOptionsResponse.json();
    const guideOptions = isGuidePreview ? responseData.previewOptions : responseData.liveOptions;

    const discordArea = document.getElementById("discord-btn-area") as HTMLDivElement;
    const discordBtnLink = document.getElementById("discord-btn-link") as HTMLAnchorElement;
    const discordButtonText = document.getElementById("discord-button-text") as HTMLElement;
    const discordButtonSubtext = document.getElementById("discord-button-subtext") as HTMLElement;
    if (guideOptions.discordButtonEnabled && guideOptions.discordButtonUrl) {
        discordArea.style.display = "block";
        discordBtnLink.href = guideOptions.discordButtonUrl;
        discordButtonText.textContent = guideOptions.discordButtonText || "Accéder au Discord";
        discordButtonSubtext.textContent = guideOptions.discordButtonSubtext || "News, liens, blabla, etc.";
    } else {
        discordArea.style.display = "none";
    }

    const outlineElement = document.getElementById("pages-outline") as HTMLDivElement;
    if (!isPaidUser) {
        const firstPaidPageUrl = guideOptions.firstPaidPageUrl;
        console.log("First paid page ID:", firstPaidPageUrl);
        const unlockSeparator = document.getElementById("unlock-separator") as HTMLDivElement;
        let foundLinkToPaidContent = false;
        if (firstPaidPageUrl !== undefined) {
            const outlineLinks = outlineElement.querySelectorAll("a");
            outlineLinks.forEach(link => {
                const linkHref = link.getAttribute("href")!;
                const linkPageId = getPageIdFromUrl(linkHref);
                const firstPaidPageId = getPageIdFromUrl(firstPaidPageUrl);
                if (linkPageId === firstPaidPageId) {
                    // Find top level toc-level
                    let parent = link.parentElement;
                    let topLevelToc: HTMLElement | null = null;
                    while (parent && parent.id !== "pages-outline") {
                        if (parent.classList.contains("toc-level")) {
                            topLevelToc = parent as HTMLElement;
                        }
                        parent = parent.parentElement;
                    }
                    if (topLevelToc) {
                        // Remove unlock separator from current position and insert before topLevelToc
                        if (unlockSeparator && unlockSeparator.parentElement) {
                            unlockSeparator.parentElement.removeChild(unlockSeparator);
                            unlockSeparator.style.display = "flex";
                            topLevelToc.parentElement!.insertBefore(unlockSeparator, topLevelToc);
                        }
                    }
                    foundLinkToPaidContent = true;
                }
                if (foundLinkToPaidContent) {
                    link.classList.add("disabled");
                    link.setAttribute("disabled", "true");
                    link.setAttribute("href", "#");
                }
            });
        }
    }

    if (isGuidePreview) {
        const url = new URL(window.location.href);
        const currentTierUrlParam = url.searchParams.get("tier");
        const isPreviewPaidTier = currentTierUrlParam !== null ? parseInt(currentTierUrlParam) > 0 : isPaidUser;
        const previewControls = document.getElementById("preview-controls") as HTMLDivElement;
        previewControls.classList.remove("hidden");
        const previewAccountSimulationButtons = previewControls.querySelectorAll(".subscription-level-btn");
        previewAccountSimulationButtons.forEach(btn => {
            const dataLevel = btn.getAttribute("data-level");
            if (dataLevel === "free" && !isPreviewPaidTier) {
                btn.classList.add("active");
            } else if (dataLevel === "paid" && isPreviewPaidTier) {
                btn.classList.add("active");
            }
            btn.addEventListener("click", () => {
                const level = btn.getAttribute("data-level");
                const currentUrl = new URL(window.location.href);
                if (level === "free") {
                    currentUrl.searchParams.set("tier", "0");
                } else {
                    currentUrl.searchParams.set("tier", "1");
                }
                window.location.href = currentUrl.toString();
            });
        });
        const closeBtn = previewControls.querySelector(".close-btn") as HTMLElement;
        closeBtn.addEventListener("click", () => {
            previewControls.classList.add("hidden");
        });
        const allLinks = outlineElement.querySelectorAll("a");
        allLinks.forEach(link => {
            const linkHref = link.getAttribute("href");
            if (linkHref == null) return;
            if (linkHref.match(/^http(s)?:\/\//)) return; // Skip external links
            const targetUrl = new URL(linkHref, window.location.href.split("/").slice(0, -1).join("/") + "/");
            targetUrl.searchParams.set("tier", isPreviewPaidTier ? "1" : "0");
            link.setAttribute("href", targetUrl.toString());
        });
    }

    outlineElement.classList.remove("hidden");
}
applyGuideOptions();

const lightbox = document.getElementById("image-lightbox") as HTMLDivElement;
const lightboxImage = lightbox.querySelector("img") as HTMLImageElement;
const images = document.querySelectorAll("main #content img");
images.forEach(img => {
    const src = img.getAttribute("src") || "";
    if (src.toLowerCase().includes("logo")) {
        img.classList.add("logo-image");
    }
    if (lightbox && lightboxImage && src) {
        (img as HTMLImageElement).style.cursor = "zoom-in";
        img.addEventListener("click", () => {
            const lightboxImage = lightbox.querySelector("img") as HTMLImageElement;
            lightboxImage.src = src;
            lightbox.classList.remove("lightbox-hidden");
        });
    }
});
lightbox.addEventListener("click", () => {  
    lightbox.classList.add("lightbox-hidden");
});

function getPageIdFromUrl(urlPath: string): string {
    if (urlPath === "index.html" || urlPath === "/guide/" || urlPath === "/guide-preview/") {
        return "index";
    }
    const pageLinkRegex = /([0-9a-fA-F]{32})\.html/g;
    const match = pageLinkRegex.exec(urlPath);
    if (match && match[1]) {
        return match[1];
    }
    console.warn("Could not extract page ID from URL path:", urlPath);
    return "";
}

function initThemeSelector() {
    const themeSelect = document.getElementById("theme-select") as HTMLSelectElement;
    if (!themeSelect) return;
    themeSelect.addEventListener("change", () => {
        const selectedTheme = themeSelect.value;
        document.body.setAttribute("data-theme", selectedTheme);
        localStorage.setItem("preferredTheme", selectedTheme);
    });
    // Load preferred theme
    const preferredTheme = localStorage.getItem("preferredTheme");
    if (preferredTheme) {
        document.body.setAttribute("data-theme", preferredTheme);
        themeSelect.value = preferredTheme;
    }
}
initThemeSelector();


// Open/close nav pane
const paneOpenBtn = document.getElementById("pane-open-btn") as HTMLButtonElement;
const paneCloseBtn = document.getElementById("pane-close-btn") as HTMLButtonElement;
paneOpenBtn.addEventListener("click", () => {
    document.body.classList.remove("closed-nav");
});
paneCloseBtn.addEventListener("click", () => {
    document.body.classList.add("closed-nav");
});

// On load, if under a certain width, close the nav
const maxWidthForClosedNav = 850;
if (window.innerWidth <= maxWidthForClosedNav) {
    document.body.classList.add("closed-nav");
}

// Fold/unfold nav outline button
const outlineUnfoldBtn = document.getElementById("outline-unfold-button") as HTMLDivElement;
if (outlineUnfoldBtn) {
    outlineUnfoldBtn.addEventListener("click", () => {
        console.log("Toggling outline fold/unfold");
        const outlineElement = document.getElementById("pages-outline") as HTMLDivElement;
        const tocLevels = outlineElement.querySelectorAll(".toc-level.has-children");
        tocLevels.forEach(tocLevel => {
            tocLevel.classList.toggle("expanded", !isOutlineFullyUnfolded);
        });
        isOutlineFullyUnfolded = !isOutlineFullyUnfolded;
        refreshOutlineUnfoldButton();
    });
}
refreshOutlineUnfoldButton();

function refreshOutlineUnfoldButton() {
    const outlineUnfoldBtn = document.getElementById("outline-unfold-button") as HTMLDivElement;
    if (outlineUnfoldBtn) {
        const textSpan = outlineUnfoldBtn.querySelector(".text") as HTMLSpanElement;
        if (isOutlineFullyUnfolded) textSpan.textContent = "Replier tout";
        else textSpan.textContent = "Déplier tout";
        outlineUnfoldBtn.classList.toggle('defold', isOutlineFullyUnfolded);
    }
}


//* MARK: Loading overlays
const loadingOverlayNav = document.getElementById("loading-overlay-nav") as HTMLDivElement;
const loadingOverlayMain = document.getElementById("loading-overlay-main") as HTMLDivElement;

if (isFirstPage) {
    window.setTimeout(() => {
        // Hide loading overlays
        if (loadingOverlayNav) loadingOverlayNav.classList.add("loading-overlay-hidden");
        if (loadingOverlayMain) loadingOverlayMain.classList.add("loading-overlay-hidden");
    }, 300);
} else {
    if (loadingOverlayNav) loadingOverlayNav.classList.add("loading-overlay-hidden-fast");
    if (loadingOverlayMain) loadingOverlayMain.classList.add("loading-overlay-hidden-fast");
}


// SPECIAL CASES
const mermaidWalkGif = document.querySelector("img[src='Walk_Sirene.gif']") as HTMLImageElement;
if (mermaidWalkGif) {
    mermaidWalkGif.style.maxHeight = "400px";
}